
export default {
  staticDomain: "//static.hsappstatic.net" || window.location.host,
  staticDomainPrefix: "//static.hsappstatic.net" || ('//' + window.location.host),
  currentProject: "documents-public-ui",
  currentProjectVersion: "static-1.35596",
  depVersions: {
  "documents-public-ui": "static-1.35596",
  "atom": "static-1.5578",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2993",
  "client-types": "static-1.512",
  "cssUtils": "static-1.1128",
  "customer-data-filters-ui": "static-1.41454",
  "customer-data-objects": "static-1.8217",
  "customer-data-property-utils": "static-1.8559",
  "documents-lib": "static-1.35601",
  "emoji-mart": "static-3.9",
  "flux-actions": "static-1.383",
  "FormsCommonComponents": "static-1.86883",
  "FormUrlGenerator": "static-2.5219",
  "foundations-theming-specialty": "static-1.2712",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.5330",
  "highcharts": "static-8.117",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.6096",
  "hs-test-utils": "static-1.8545",
  "hub-http": "static-1.6710",
  "hubspot-dlb": "static-2.1911",
  "HubStyle": "static-2.12301",
  "HubStyleTokens": "static-2.11994",
  "I18n": "static-7.1716",
  "icons": "static-2.710",
  "jasmine-immutable": "static-1.3443",
  "jasmine-runner": "static-1.6959",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.7653",
  "lodash": "static-1.3",
  "PatternValidationJS": "static-1.3389",
  "pdf-js": "static-2.49",
  "property-translator": "static-1.5885",
  "quartz": "static-1.7695",
  "react": "static-7.204",
  "react-dlb": "static-1.96",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.80",
  "react-rhumb": "static-1.17243",
  "react-select-plus": "static-1.120",
  "react-utils": "static-2.5682",
  "react-virtualized": "static-2.114",
  "reference-resolvers": "static-1.8690",
  "reference-resolvers-lite": "static-1.8619",
  "reporting-data": "static-1.69472",
  "reporting-reports": "static-1.69148",
  "reporting-snowflake": "static-1.58088",
  "reporting-testing-lib": "static-1.11405",
  "reporting-visualizations": "static-1.61546",
  "reselect": "static-3.18",
  "sales-content-partitioning": "static-1.9465",
  "sanitize": "static-1.4974",
  "sanitize-text": "static-1.8664",
  "SharedI18nStrings": "static-1.190",
  "SharedLegalStrings": "static-1.2232",
  "signup-constants": "static-1.20005",
  "signup-ui-url-generator": "static-2.8542",
  "StyleGuideUI": "static-3.520",
  "superstore": "static-1.5262",
  "tinymce": "static-6.5",
  "transmute": "static-2.97",
  "ui-addon-draggable": "static-3.5257",
  "ui-addon-form-validation": "static-1.11352",
  "ui-asset-management-lib": "static-1.11609",
  "ui-images": "static-2.1284",
  "UIComponents": "static-3.8940",
  "usage-tracker": "static-1.7826",
  "usage-tracker-container": "static-1.7816",
  "usage-tracker-core": "static-1.7676",
  "viral-links-lib": "static-1.7587",
  "webpack-env": "static-1.54",
  "data-fetching-client": "static-1.10143",
  "foundations-components": "static-1.8795",
  "immutable": "static-2.88",
  "isMobile": "static-1.7",
  "PortalIdParser": "static-2.458",
  "quartz-config": "static-1.1473",
  "quartz-core": "static-1.6914",
  "quick-fetch": "static-1.4246",
  "raven": "static-3.6411",
  "redux": "static-4.81",
  "redux-thunk": "static-2.86",
  "rpc-client-utils": "static-1.5170",
  "ui-addon-i18n": "static-1.11651",
  "ui-addon-upgrades": "static-9.18568",
  "enviro": "static-4.523",
  "hs-promise-rejection-tracking": "static-1.6078",
  "raven-hubspot": "static-1.6718",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "hubspot-url-utils": "static-1.4383",
  "metrics-js": "static-1.9990",
  "styled-components": "static-2.100",
  "moment": "static-3.75",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3972",
  "quartz-webpack": "static-1.3919",
  "foundations-assets": "static-1.5395",
  "foundations-theming": "static-1.4996",
  "hub-http-janus": "static-1.914",
  "hub-http-shared-msw-handlers": "static-1.10951",
  "hubspotter-http": "static-1.4990",
  "trellis-components": "static-1.3188",
  "trellis-migration-context": "static-1.84",
  "sassPrefix": "static-1.391",
  "conversations-skeleton-state": "static-1.7622",
  "crm-message-bus": "static-1.44163",
  "customer-data-filters-ui-msw-helpers": "static-1.23889",
  "customer-data-objects-ui-components": "static-1.13540",
  "customer-data-reference-ui-components": "static-1.13679",
  "customer-data-ui-utilities": "static-1.10338",
  "events-data-lib": "static-1.753",
  "framework-builder-read-service-client": "static-1.4351",
  "hs-resources": "static-1.692",
  "immer": "static-1.107",
  "inbound-db-meta-service-client": "static-1.3790",
  "inbound-db-properties-service-client": "static-1.4167",
  "multi-account-reference-resolvers": "static-1.1520",
  "onboarding-tours": "static-1.17433",
  "pulse": "static-1.1158",
  "reporting-datasets-permissions-lib": "static-1.14816",
  "segments-client-types": "static-1.12276",
  "stylex": "static-1.48",
  "trellis-assets": "static-1.3169",
  "trellis-theming": "static-1.1525",
  "ui-addon-teams": "static-1.22044",
  "quartz-auth": "static-1.1370",
  "ui-business-units-lib": "static-1.9602",
  "usage-tracker-session-replay": "static-1.5512",
  "ai-components-ui-library": "static-1.10073",
  "ContentUtils": "static-1.69541",
  "customer-data-properties": "static-1.53147",
  "forms-ai-lib": "static-1.5021",
  "forms-utils-lib": "static-1.13381",
  "foundations-components-test-utils": "static-1.6278",
  "react-dnd-compat": "static-1.5112",
  "react-tinymce": "static-1.56321",
  "tinymce-config": "static-2.55447",
  "ui-gdpr-components": "static-1.10658",
  "underscore": "static-1.8",
  "foundations-theming-base": "static-1.3981",
  "HeadJS": "static-2.830",
  "framer-motion": "static-1.86",
  "hs-test-utils-bend-plugin": "static-1.3656",
  "msw": "static-1.105",
  "msw-config": "static-1.36",
  "testing-library": "static-1.167",
  "hs-locale-management": "static-1.418",
  "ui-fonts": "static-1.1256",
  "i18n-data": "static-1.237",
  "moment-timezone": "static-5.98",
  "jasmine": "static-4.4810",
  "csstype": "static-1.50",
  "beacon-keepalive-queue": "static-1.205",
  "quartz-head": "static-1.1360",
  "web-vitals": "static-1.21",
  "batch-promise": "static-1.2056",
  "external-options-client-types": "static-1.4454",
  "fast-json-stable-stringify": "static-1.4",
  "quartz-i18n": "static-1.1370",
  "frontend-preferences-client": "static-1.8426",
  "graphql": "static-1.95",
  "persist-promise": "static-1.4213",
  "reporting-client-types": "static-1.2865",
  "apollo-stack-hubspot": "static-3.101",
  "hubspot-apollo-client": "static-1.5387",
  "foundations-components-legacy": "static-1.1820",
  "quartz-routing": "static-1.1125",
  "hs-story-utils": "static-1.9934",
  "react-flip-move": "static-1.85",
  "nested-table": "static-1.731",
  "seat-types-lib": "static-1.1100",
  "timezone-utils": "static-2.5734",
  "react-create-root-preference": "static-1.112",
  "bend-plugin-foundations-components": "static-1.5064",
  "floating-ui": "static-1.70",
  "react-aria": "static-1.79",
  "tanstack-table": "static-1.68",
  "opentelemetry-fe-types": "static-1.298",
  "dispatcher": "static-1.150",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.612",
  "module-federation": "static-1.42",
  "opentelemetry-fe": "static-1.673",
  "quartz-test": "static-1.1370",
  "quartz-tracking": "static-1.1074",
  "bend-plugin-chirp-manifest": "static-1.580",
  "chirp-fetch": "static-1.2409",
  "merchandise-lib": "static-1.288",
  "purchase-motions-components": "static-1.6672",
  "ts-schema": "static-1.4410",
  "bender-build-tools": "static-1.3620",
  "bend-plugin-foundations-theming": "static-1.3479",
  "base-ui": "static-1.31",
  "react-day-picker": "static-1.17",
  "tanstack-virtual": "static-1.45",
  "restore-request-side-panel-lib": "static-1.2095",
  "react-immutable-render-mixin": "static-1.9",
  "apollo-link-hub-http": "static-2.5095",
  "conditional-properties-service-client": "static-1.4129",
  "crm-pipelines-api-client-types": "static-1.4459",
  "event-emitter": "static-1.1465",
  "fdsr-migration-layer": "static-1.519",
  "multi-currency-client-types": "static-1.4024",
  "getting-started-shared-tasks": "static-1.19614",
  "growth-data-modal": "static-1.6173",
  "growth-onboarding-confetti": "static-1.3564",
  "growth-onboarding-next-action-utils": "static-1.3035",
  "navigation-components": "static-1.19225",
  "nest": "static-1.742",
  "onboarding-tours-client": "static-1.5648",
  "onboarding-tours-utils": "static-1.1500",
  "ui-shepherd-react": "static-3.10788",
  "ui-shepherd-tracker": "static-1.8169",
  "ui-universal-auth": "static-1.9799",
  "user-context": "static-1.5561",
  "bend-plugin-pulse": "static-1.661",
  "fast-json-patch": "static-1.76",
  "crm-index-associations-lib": "static-1.6955",
  "stylex-utils": "static-1.183",
  "hubspotter-http-shared-msw-handlers": "static-1.10949",
  "magpie-lib": "static-1.5933",
  "navigation-messaging": "static-1.8552",
  "amplitude-session-replay-browser": "static-1.60",
  "chatspot-core": "static-1.24054",
  "copilot-toolkit": "static-1.12204",
  "cms-field-types": "static-1.5317",
  "content-icons-ui": "static-1.2487",
  "integrations-lib": "static-1.17491",
  "calling-global-api": "static-1.66285",
  "calling-internal-common": "static-1.31828",
  "calling-lifecycle-internal": "static-1.67667",
  "calling-lifecycle-messages": "static-1.59959",
  "commerce-products-lib": "static-1.10984",
  "crm-index-visualization-core": "static-1.4798",
  "crm-links": "static-1.6819",
  "customer-data-properties-shared-msw-handlers": "static-1.10278",
  "data-agent-utils": "static-1.977",
  "data-token-picker": "static-1.17180",
  "file-manager-components": "static-1.24886",
  "formula-editor": "static-1.15049",
  "google-libphonenumber": "static-1.52",
  "inbounddb-objects-service-types": "static-1.4530",
  "meetings-icalendar-utils-lib": "static-1.1138",
  "object-builder-ui-client": "static-1.50113",
  "pipeline-validation-client-types": "static-1.4299",
  "property-value-citations": "static-1.3761",
  "react-colorpicker": "static-2.10713",
  "rich-text-lib": "static-1.20601",
  "smart-data-capture-core": "static-1.540",
  "tiered-pricing": "static-1.2331",
  "tinymce-plugins": "static-1.58561",
  "tinymce-themes": "static-1.57417",
  "topics-actions-lib": "static-1.691",
  "trellis-ext-i18n": "static-1.1429",
  "trial-components-library": "static-1.14432",
  "ui-addon-emoji-picker": "static-1.10369",
  "ui-addon-iframeable": "static-1.9585",
  "zustand": "static-1.91",
  "final-form": "static-1.85",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.84",
  "hub-http-contrib": "static-1.3536",
  "interframe": "static-3.5247",
  "tinymce-data": "static-1.41532",
  "ui-addon-sales-email": "static-1.5709",
  "hubspot-apollo-cache": "static-1.846",
  "react-window": "static-1.13",
  "ts-utils-lib": "static-1.658",
  "opentelemetry-web": "static-1.25",
  "onboarding-scopes": "static-1.6957",
  "purchase-motions-api": "static-1.6675",
  "onboarding-data-sync-lib": "static-1.2878",
  "growth-onboarding-next-action-components": "static-1.3063",
  "user-context-client": "static-1.5015",
  "idb-keyval": "static-1.57",
  "magpie-types": "static-1.5393",
  "reactive-lib": "static-1.1226",
  "simple-logging-lib": "static-1.3555",
  "custom-vendor-connection-lib": "static-1.363",
  "unified-auth-core-lib": "static-1.1595",
  "getting-started-shared-tasks-store": "static-1.18732",
  "nav-meta": "static-1.30862",
  "markdown-it": "static-1.6",
  "breeze-engine-lib": "static-1.2272",
  "integrations-error-boundary-lib": "static-1.14906",
  "integrations-tracking-lib": "static-1.6129",
  "native-integrations-shared-strings": "static-1.8266",
  "redux-observable": "static-1.81",
  "ReduxMessenger": "static-2.10876",
  "rxjs": "static-5.10",
  "calling-error-reporting": "static-1.31835",
  "shared-worker-versioning": "static-1.11548",
  "calling-usage-tracker": "static-1.7047",
  "customer-data-tracking": "static-1.7376",
  "voice-sms-access-library": "static-1.2538",
  "commerce-permissions": "static-1.1291",
  "growth-payments-core": "static-1.26553",
  "products-iframe-lib": "static-1.8969",
  "products-ui-components-shared-msw-handlers": "static-1.11333",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.11034",
  "sales-views-client-types": "static-1.4764",
  "framework-data-schema-resolvers": "static-1.7400",
  "location-customization-utils-lib": "static-1.10477",
  "data-agent-kit": "static-1.964",
  "enrichment-settings-lib": "static-1.310",
  "fsm": "static-1.4264",
  "policy-lib": "static-1.7310",
  "apollo-dlb": "static-3.98",
  "immerable": "static-1.4647",
  "poll-commands": "static-1.3981",
  "video-components-external": "static-1.12494",
  "video-data-lib": "static-1.36152",
  "bark-lib": "static-1.17038",
  "browser-prettier": "static-1.11",
  "codemirror": "static-5.108",
  "crm-properties-common-lib": "static-1.6403",
  "react-codemirror": "static-1.11148",
  "FileManagerLib": "static-1.40526",
  "content-assistance-lib": "static-1.8464",
  "FileManagerCore": "static-1.40385",
  "layout-dnd-components": "static-1.13269",
  "layout-dnd-utils": "static-1.12244",
  "ui-brand-identity-lib": "static-1.17015",
  "NamespacedHubStyle": "static-2.9383",
  "embedded-academy-lib": "static-1.16095",
  "hubs-service-types": "static-1.1771",
  "nudge-client-utils": "static-1.3464",
  "salesImages": "static-1.761",
  "InboxConnectUtils": "static-4.15891",
  "meetings-connect-utils-lib": "static-1.8124",
  "ably": "static-2.2",
  "breeze-engine-chat-components": "static-1.1250",
  "breeze-engine-core": "static-1.1550",
  "highlight.js": "static-1.92",
  "universal-page-editor-lib": "static-1.3519",
  "calling-orchestration-schema": "static-1.37315",
  "ui-addon-opt": "static-4.8924",
  "framework-data-schema-quick-fetch": "static-1.7305",
  "crm-record-cards-service-types": "static-1.3877",
  "trellis-story-utils": "static-1.5003",
  "storybook-react": "static-1.46",
  "content-media-composition-data-lib": "static-1.13642",
  "content-media-compositions": "static-2.17649",
  "media-bridge-lib": "static-1.19684",
  "diff-match-patch": "static-1.7",
  "react-reducer-toolkit": "static-1.16715",
  "browser-eslint": "static-2.57",
  "audio-components": "static-1.6612",
  "FileManagerImages": "static-1.38037",
  "video-components": "static-1.14496",
  "ui-addon-video-player": "static-1.9127",
  "ui-coaching-tips": "static-1.29613",
  "breeze-artifacts-sdk": "static-1.1083",
  "cropperjs": "static-1.10",
  "feedback-loader": "static-1.30102",
  "html-to-image": "static-1.67",
  "urlinator": "static-1.5020",
  "video-embed": "static-1.36986",
  "ContentData": "static-1.69616",
  "layout-data-lib": "static-1.10569",
  "academy-common-lib": "static-1.15556",
  "nudge-custom-function-registry": "static-1.3221",
  "nudge-renderer-utils": "static-1.3540",
  "whisper-core-api": "static-1.7677",
  "crm-record-cards-client": "static-1.125",
  "social-insights-client-types": "static-1.22977",
  "growth-onboarding-feedback-components": "static-1.7087",
  "outpost": "static-1.4636",
  "advanced-menus-core": "static-1.15862",
  "advanced-menus-lib": "static-1.12604",
  "ExportDialog": "static-6.10878",
  "ui-memberships-settings-lib": "static-1.35254",
  "academy-service-client": "static-1.4198",
  "croppie": "static-2.10",
  "SafeStorage": "static-1.4901",
  "trellis-ecosystem": "static-1.7894",
  "ui-addon-react-router-dom": "static-1.10031",
  "wootric-nps": "static-1.7313",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15861",
  "simple-menus-lib": "static-1.17378",
  "settings-ui-lib": "static-1.13034",
  "marketplace-ui-apps-core": "static-1.19612",
  "marketplace-ui-common": "static-1.21080",
  "developer-experience-shared-components": "static-1.11047",
  "immutable-less": "static-1.5157",
  "marketplace-ui-client-types": "static-1.18487",
  "ui-addon-integrations-directory-panel": "static-2.8458",
  "ui-extensibility-client-types": "static-1.4421",
  "ai-settings-ui-library": "static-1.8636",
  "ui-product-approvals-common": "static-1.1686",
  "apps-service-types": "static-1.4115",
  "oauth-service-types": "static-1.4642",
  "simple-data-table": "static-1.3871"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.35596",
  "atom": "/atom/static-1.5578",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2993",
  "client-types": "/client-types/static-1.512",
  "cssUtils": "/cssUtils/static-1.1128",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.41454",
  "customer-data-objects": "/customer-data-objects/static-1.8217",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8559",
  "documents-lib": "/documents-lib/static-1.35601",
  "emoji-mart": "/emoji-mart/static-3.9",
  "flux-actions": "/flux-actions/static-1.383",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.86883",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.5219",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2712",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.5330",
  "highcharts": "/highcharts/static-8.117",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.6096",
  "hs-test-utils": "/hs-test-utils/static-1.8545",
  "hub-http": "/hub-http/static-1.6710",
  "hubspot-dlb": "/hubspot-dlb/static-2.1911",
  "HubStyle": "/HubStyle/static-2.12301",
  "HubStyleTokens": "/HubStyleTokens/static-2.11994",
  "I18n": "/I18n/static-7.1716",
  "icons": "/icons/static-2.710",
  "jasmine-immutable": "/jasmine-immutable/static-1.3443",
  "jasmine-runner": "/jasmine-runner/static-1.6959",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.7653",
  "lodash": "/lodash/static-1.3",
  "PatternValidationJS": "/PatternValidationJS/static-1.3389",
  "pdf-js": "/pdf-js/static-2.49",
  "property-translator": "/property-translator/static-1.5885",
  "quartz": "/quartz/static-1.7695",
  "react": "/react/static-7.204",
  "react-dlb": "/react-dlb/static-1.96",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.80",
  "react-rhumb": "/react-rhumb/static-1.17243",
  "react-select-plus": "/react-select-plus/static-1.120",
  "react-utils": "/react-utils/static-2.5682",
  "react-virtualized": "/react-virtualized/static-2.114",
  "reference-resolvers": "/reference-resolvers/static-1.8690",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8619",
  "reporting-data": "/reporting-data/static-1.69472",
  "reporting-reports": "/reporting-reports/static-1.69148",
  "reporting-snowflake": "/reporting-snowflake/static-1.58088",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.11405",
  "reporting-visualizations": "/reporting-visualizations/static-1.61546",
  "reselect": "/reselect/static-3.18",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.9465",
  "sanitize": "/sanitize/static-1.4974",
  "sanitize-text": "/sanitize-text/static-1.8664",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.190",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.2232",
  "signup-constants": "/signup-constants/static-1.20005",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8542",
  "StyleGuideUI": "/StyleGuideUI/static-3.520",
  "superstore": "/superstore/static-1.5262",
  "tinymce": "/tinymce/static-6.5",
  "transmute": "/transmute/static-2.97",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5257",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11352",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11609",
  "ui-images": "/ui-images/static-2.1284",
  "UIComponents": "/UIComponents/static-3.8940",
  "usage-tracker": "/usage-tracker/static-1.7826",
  "usage-tracker-container": "/usage-tracker-container/static-1.7816",
  "usage-tracker-core": "/usage-tracker-core/static-1.7676",
  "viral-links-lib": "/viral-links-lib/static-1.7587",
  "webpack-env": "/webpack-env/static-1.54",
  "data-fetching-client": "/data-fetching-client/static-1.10143",
  "foundations-components": "/foundations-components/static-1.8795",
  "immutable": "/immutable/static-2.88",
  "isMobile": "/isMobile/static-1.7",
  "PortalIdParser": "/PortalIdParser/static-2.458",
  "quartz-config": "/quartz-config/static-1.1473",
  "quartz-core": "/quartz-core/static-1.6914",
  "quick-fetch": "/quick-fetch/static-1.4246",
  "raven": "/raven/static-3.6411",
  "redux": "/redux/static-4.81",
  "redux-thunk": "/redux-thunk/static-2.86",
  "rpc-client-utils": "/rpc-client-utils/static-1.5170",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11651",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18568",
  "enviro": "/enviro/static-4.523",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.6078",
  "raven-hubspot": "/raven-hubspot/static-1.6718",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4383",
  "metrics-js": "/metrics-js/static-1.9990",
  "styled-components": "/styled-components/static-2.100",
  "moment": "/moment/static-3.75",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3972",
  "quartz-webpack": "/quartz-webpack/static-1.3919",
  "foundations-assets": "/foundations-assets/static-1.5395",
  "foundations-theming": "/foundations-theming/static-1.4996",
  "hub-http-janus": "/hub-http-janus/static-1.914",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10951",
  "hubspotter-http": "/hubspotter-http/static-1.4990",
  "trellis-components": "/trellis-components/static-1.3188",
  "trellis-migration-context": "/trellis-migration-context/static-1.84",
  "sassPrefix": "/sassPrefix/static-1.391",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7622",
  "crm-message-bus": "/crm-message-bus/static-1.44163",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.23889",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13540",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13679",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10338",
  "events-data-lib": "/events-data-lib/static-1.753",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4351",
  "hs-resources": "/hs-resources/static-1.692",
  "immer": "/immer/static-1.107",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3790",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4167",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1520",
  "onboarding-tours": "/onboarding-tours/static-1.17433",
  "pulse": "/pulse/static-1.1158",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.14816",
  "segments-client-types": "/segments-client-types/static-1.12276",
  "stylex": "/stylex/static-1.48",
  "trellis-assets": "/trellis-assets/static-1.3169",
  "trellis-theming": "/trellis-theming/static-1.1525",
  "ui-addon-teams": "/ui-addon-teams/static-1.22044",
  "quartz-auth": "/quartz-auth/static-1.1370",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9602",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5512",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.10073",
  "ContentUtils": "/ContentUtils/static-1.69541",
  "customer-data-properties": "/customer-data-properties/static-1.53147",
  "forms-ai-lib": "/forms-ai-lib/static-1.5021",
  "forms-utils-lib": "/forms-utils-lib/static-1.13381",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.6278",
  "react-dnd-compat": "/react-dnd-compat/static-1.5112",
  "react-tinymce": "/react-tinymce/static-1.56321",
  "tinymce-config": "/tinymce-config/static-2.55447",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10658",
  "underscore": "/underscore/static-1.8",
  "foundations-theming-base": "/foundations-theming-base/static-1.3981",
  "HeadJS": "/HeadJS/static-2.830",
  "framer-motion": "/framer-motion/static-1.86",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3656",
  "msw": "/msw/static-1.105",
  "msw-config": "/msw-config/static-1.36",
  "testing-library": "/testing-library/static-1.167",
  "hs-locale-management": "/hs-locale-management/static-1.418",
  "ui-fonts": "/ui-fonts/static-1.1256",
  "i18n-data": "/i18n-data/static-1.237",
  "moment-timezone": "/moment-timezone/static-5.98",
  "jasmine": "/jasmine/static-4.4810",
  "csstype": "/csstype/static-1.50",
  "beacon-keepalive-queue": "/beacon-keepalive-queue/static-1.205",
  "quartz-head": "/quartz-head/static-1.1360",
  "web-vitals": "/web-vitals/static-1.21",
  "batch-promise": "/batch-promise/static-1.2056",
  "external-options-client-types": "/external-options-client-types/static-1.4454",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "quartz-i18n": "/quartz-i18n/static-1.1370",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8426",
  "graphql": "/graphql/static-1.95",
  "persist-promise": "/persist-promise/static-1.4213",
  "reporting-client-types": "/reporting-client-types/static-1.2865",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.101",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5387",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1820",
  "quartz-routing": "/quartz-routing/static-1.1125",
  "hs-story-utils": "/hs-story-utils/static-1.9934",
  "react-flip-move": "/react-flip-move/static-1.85",
  "nested-table": "/nested-table/static-1.731",
  "seat-types-lib": "/seat-types-lib/static-1.1100",
  "timezone-utils": "/timezone-utils/static-2.5734",
  "react-create-root-preference": "/react-create-root-preference/static-1.112",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.5064",
  "floating-ui": "/floating-ui/static-1.70",
  "react-aria": "/react-aria/static-1.79",
  "tanstack-table": "/tanstack-table/static-1.68",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.298",
  "dispatcher": "/dispatcher/static-1.150",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.612",
  "module-federation": "/module-federation/static-1.42",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.673",
  "quartz-test": "/quartz-test/static-1.1370",
  "quartz-tracking": "/quartz-tracking/static-1.1074",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.580",
  "chirp-fetch": "/chirp-fetch/static-1.2409",
  "merchandise-lib": "/merchandise-lib/static-1.288",
  "purchase-motions-components": "/purchase-motions-components/static-1.6672",
  "ts-schema": "/ts-schema/static-1.4410",
  "bender-build-tools": "/bender-build-tools/static-1.3620",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3479",
  "base-ui": "/base-ui/static-1.31",
  "react-day-picker": "/react-day-picker/static-1.17",
  "tanstack-virtual": "/tanstack-virtual/static-1.45",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.2095",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.5095",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4129",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4459",
  "event-emitter": "/event-emitter/static-1.1465",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.519",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.4024",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19614",
  "growth-data-modal": "/growth-data-modal/static-1.6173",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3564",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.3035",
  "navigation-components": "/navigation-components/static-1.19225",
  "nest": "/nest/static-1.742",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5648",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1500",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10788",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.8169",
  "ui-universal-auth": "/ui-universal-auth/static-1.9799",
  "user-context": "/user-context/static-1.5561",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.661",
  "fast-json-patch": "/fast-json-patch/static-1.76",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6955",
  "stylex-utils": "/stylex-utils/static-1.183",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10949",
  "magpie-lib": "/magpie-lib/static-1.5933",
  "navigation-messaging": "/navigation-messaging/static-1.8552",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "chatspot-core": "/chatspot-core/static-1.24054",
  "copilot-toolkit": "/copilot-toolkit/static-1.12204",
  "cms-field-types": "/cms-field-types/static-1.5317",
  "content-icons-ui": "/content-icons-ui/static-1.2487",
  "integrations-lib": "/integrations-lib/static-1.17491",
  "calling-global-api": "/calling-global-api/static-1.66285",
  "calling-internal-common": "/calling-internal-common/static-1.31828",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.67667",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.59959",
  "commerce-products-lib": "/commerce-products-lib/static-1.10984",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4798",
  "crm-links": "/crm-links/static-1.6819",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.10278",
  "data-agent-utils": "/data-agent-utils/static-1.977",
  "data-token-picker": "/data-token-picker/static-1.17180",
  "file-manager-components": "/file-manager-components/static-1.24886",
  "formula-editor": "/formula-editor/static-1.15049",
  "google-libphonenumber": "/google-libphonenumber/static-1.52",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4530",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.1138",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.50113",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4299",
  "property-value-citations": "/property-value-citations/static-1.3761",
  "react-colorpicker": "/react-colorpicker/static-2.10713",
  "rich-text-lib": "/rich-text-lib/static-1.20601",
  "smart-data-capture-core": "/smart-data-capture-core/static-1.540",
  "tiered-pricing": "/tiered-pricing/static-1.2331",
  "tinymce-plugins": "/tinymce-plugins/static-1.58561",
  "tinymce-themes": "/tinymce-themes/static-1.57417",
  "topics-actions-lib": "/topics-actions-lib/static-1.691",
  "trellis-ext-i18n": "/trellis-ext-i18n/static-1.1429",
  "trial-components-library": "/trial-components-library/static-1.14432",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10369",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9585",
  "zustand": "/zustand/static-1.91",
  "final-form": "/final-form/static-1.85",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.84",
  "hub-http-contrib": "/hub-http-contrib/static-1.3536",
  "interframe": "/interframe/static-3.5247",
  "tinymce-data": "/tinymce-data/static-1.41532",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5709",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.846",
  "react-window": "/react-window/static-1.13",
  "ts-utils-lib": "/ts-utils-lib/static-1.658",
  "opentelemetry-web": "/opentelemetry-web/static-1.25",
  "onboarding-scopes": "/onboarding-scopes/static-1.6957",
  "purchase-motions-api": "/purchase-motions-api/static-1.6675",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2878",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.3063",
  "user-context-client": "/user-context-client/static-1.5015",
  "idb-keyval": "/idb-keyval/static-1.57",
  "magpie-types": "/magpie-types/static-1.5393",
  "reactive-lib": "/reactive-lib/static-1.1226",
  "simple-logging-lib": "/simple-logging-lib/static-1.3555",
  "custom-vendor-connection-lib": "/custom-vendor-connection-lib/static-1.363",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1595",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18732",
  "nav-meta": "/nav-meta/static-1.30862",
  "markdown-it": "/markdown-it/static-1.6",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.2272",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14906",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.6129",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8266",
  "redux-observable": "/redux-observable/static-1.81",
  "ReduxMessenger": "/ReduxMessenger/static-2.10876",
  "rxjs": "/rxjs/static-5.10",
  "calling-error-reporting": "/calling-error-reporting/static-1.31835",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11548",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.7047",
  "customer-data-tracking": "/customer-data-tracking/static-1.7376",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.2538",
  "commerce-permissions": "/commerce-permissions/static-1.1291",
  "growth-payments-core": "/growth-payments-core/static-1.26553",
  "products-iframe-lib": "/products-iframe-lib/static-1.8969",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.11333",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.11034",
  "sales-views-client-types": "/sales-views-client-types/static-1.4764",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7400",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10477",
  "data-agent-kit": "/data-agent-kit/static-1.964",
  "enrichment-settings-lib": "/enrichment-settings-lib/static-1.310",
  "fsm": "/fsm/static-1.4264",
  "policy-lib": "/policy-lib/static-1.7310",
  "apollo-dlb": "/apollo-dlb/static-3.98",
  "immerable": "/immerable/static-1.4647",
  "poll-commands": "/poll-commands/static-1.3981",
  "video-components-external": "/video-components-external/static-1.12494",
  "video-data-lib": "/video-data-lib/static-1.36152",
  "bark-lib": "/bark-lib/static-1.17038",
  "browser-prettier": "/browser-prettier/static-1.11",
  "codemirror": "/codemirror/static-5.108",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6403",
  "react-codemirror": "/react-codemirror/static-1.11148",
  "FileManagerLib": "/FileManagerLib/static-1.40526",
  "content-assistance-lib": "/content-assistance-lib/static-1.8464",
  "FileManagerCore": "/FileManagerCore/static-1.40385",
  "layout-dnd-components": "/layout-dnd-components/static-1.13269",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.12244",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.17015",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9383",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.16095",
  "hubs-service-types": "/hubs-service-types/static-1.1771",
  "nudge-client-utils": "/nudge-client-utils/static-1.3464",
  "salesImages": "/salesImages/static-1.761",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15891",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.8124",
  "ably": "/ably/static-2.2",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.1250",
  "breeze-engine-core": "/breeze-engine-core/static-1.1550",
  "highlight.js": "/highlight.js/static-1.92",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3519",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.37315",
  "ui-addon-opt": "/ui-addon-opt/static-4.8924",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7305",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3877",
  "trellis-story-utils": "/trellis-story-utils/static-1.5003",
  "storybook-react": "/storybook-react/static-1.46",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13642",
  "content-media-compositions": "/content-media-compositions/static-2.17649",
  "media-bridge-lib": "/media-bridge-lib/static-1.19684",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16715",
  "browser-eslint": "/browser-eslint/static-2.57",
  "audio-components": "/audio-components/static-1.6612",
  "FileManagerImages": "/FileManagerImages/static-1.38037",
  "video-components": "/video-components/static-1.14496",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.9127",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29613",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.1083",
  "cropperjs": "/cropperjs/static-1.10",
  "feedback-loader": "/feedback-loader/static-1.30102",
  "html-to-image": "/html-to-image/static-1.67",
  "urlinator": "/urlinator/static-1.5020",
  "video-embed": "/video-embed/static-1.36986",
  "ContentData": "/ContentData/static-1.69616",
  "layout-data-lib": "/layout-data-lib/static-1.10569",
  "academy-common-lib": "/academy-common-lib/static-1.15556",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.3221",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3540",
  "whisper-core-api": "/whisper-core-api/static-1.7677",
  "crm-record-cards-client": "/crm-record-cards-client/static-1.125",
  "social-insights-client-types": "/social-insights-client-types/static-1.22977",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.7087",
  "outpost": "/outpost/static-1.4636",
  "advanced-menus-core": "/advanced-menus-core/static-1.15862",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12604",
  "ExportDialog": "/ExportDialog/static-6.10878",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.35254",
  "academy-service-client": "/academy-service-client/static-1.4198",
  "croppie": "/croppie/static-2.10",
  "SafeStorage": "/SafeStorage/static-1.4901",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7894",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.10031",
  "wootric-nps": "/wootric-nps/static-1.7313",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15861",
  "simple-menus-lib": "/simple-menus-lib/static-1.17378",
  "settings-ui-lib": "/settings-ui-lib/static-1.13034",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19612",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.21080",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.11047",
  "immutable-less": "/immutable-less/static-1.5157",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.18487",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8458",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4421",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8636",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.1686",
  "apps-service-types": "/apps-service-types/static-1.4115",
  "oauth-service-types": "/oauth-service-types/static-1.4642",
  "simple-data-table": "/simple-data-table/static-1.3871"
}
};
